import { useEffect, useState } from 'react'

export const useChatbotOpen = () => {
    const [isChatOpen, setIsChatOpen] = useState(false)

    useEffect(() => {
        const onOpen = () => {
            setIsChatOpen(true)
        }
        const onClose = () => {
            setIsChatOpen(false)
        }

        window.addEventListener('chatOpened', onOpen)
        window.addEventListener('chatClosed', onClose)

        return () => {
            window.removeEventListener('chatOpened', onOpen)
            window.removeEventListener('chatClosed', onClose)
        }
    }, [])

    return { isChatOpen }
}
